import { render } from "./Start.vue?vue&type=template&id=4476fdac&scoped=true"
import script from "./Start.vue?vue&type=script&lang=js"
export * from "./Start.vue?vue&type=script&lang=js"

import "./Start.vue?vue&type=style&index=0&id=4476fdac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4476fdac"]])

export default __exports__